import * as React from 'react';
import { CSVLink as CL } from 'react-csv';
import styled from 'styled-components';
import { minWidth, space, width, background } from 'styled-system';

const Wrapper = styled(CL)`
  padding: 10px;
  text-align: center;
  text-decoration: none;
  border-radius: 5px;
  color: white;
  ${minWidth};
  ${width};
  ${space};
  ${background};
`;

const CSVLink: React.FC<any> = props => {
  const { innerRef, ...rest } = props;
  return <Wrapper {...rest} ref={innerRef} />;
};

CSVLink.defaultProps = {
  width: '150px',
  background: '#d69b30',
};

export default CSVLink;
